import { create } from 'zustand';
import { Data } from '../interfaces';

interface IUseData {
  experienceId: string | null;
  setExperienceId: (experienceId: string | null) => void;
  gtin: string | null;
  setGtin: (gtin: string | null) => void;
  data: Data | null;
  setData: (data: Data | null) => void;
}

export const useData = create<IUseData>((set) => ({
  experienceId: null,
  setExperienceId: (experienceId) =>
    set(() => ({
      experienceId,
    })),
  gtin: null,
  setGtin: (gtin) =>
    set(() => ({
      gtin,
    })),
  data: null,
  setData: (data) =>
    set(() => ({
      data,
    })),
}));
